export function removeFromURL(key: string): void {
    if (!key) {
        return;
    }

    // don't mutate the state if the key isn't present
    if (!window.location.search.toLowerCase().includes(key.toLowerCase())) {
        return;
    }
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(key);
    const newUrl = `${window.location.origin}${
        window.location.pathname
    }?${urlParams.toString()}`;
    window.history.replaceState(null, '', newUrl);
}
